<template>
    <div>
        <header-vue></header-vue>
        <div style="height: 40px"></div>
        <div class="banner">
            <p class="card-text" style="white-space: pre-line">
                    1.Apple ID・iCloudやGoogleアカウントのサインアウト、端末本体のリセットを行なってください。初期化忘れ等において万が一、不足の事態が起きても弊社では一切の責任を負いかねます。<br>
                    2.必ず携帯端末からSIMカードを取り出してからご発送ください。SIMカードの抜き忘れなどで、不正利用などの損害、トラブルが発生しても弊社では一切の責任を負いかねます。<br>
                    3.当店との売買成立後に、不正利用によって、ネットワーク利用制限が「×」になった場合、警察への被害届け及び損害賠償請求を行います。<br>
                    <br>
                    <br>
                    ご注意：以下事項に該当する商品は買取できません<br>
                    <br>
                    【 携帯電話 】<br>
                    • ネットワーク利用制限中のドコモ・ソフトバンク端末・au端末(一部機種除く)<br>
                    • パスワードや遠隔ロック、アクティベーションロックが解除出来ない商品<br>
                    • 動作確認できない商品(故障している、破損している)<br>
                    • 不正購入・盗難・契約不履行（料金滞納等）の商品<br>
                    • 改造・水没・故障（iPhone/iPadを除く）端末<br>
                    • 各キャリアによるサービス対応が終了した機種<br>
                    • ICロックがかかっている端末<br>
                    【 家電商品 】<br>
                    • 外箱及び内箱などに破損や著しい汚れ、傷みのある商品<br>
                    • ペアレンタルコントロールが設定されている商品<br>
                    【 日用品 】<br>
                    • ご使用になられている中古の商品<br>
                    • 外箱及び内箱などに破損や傷みのある商品<br>
                    • 賞味期限・使用期限の切れた商品または賞味期限・使用期限の近い商品<br>
                    <br>
                    【 全般 】<br>
                    • 不正な商品（非ライセンス商品・模倣品・海賊版）またはその疑いがある商品<br>
                    • 盗品、もしくは当店にて盗品に準ずるものと判断した商品<br>
                    • 海外版、輸入版、偽物等の商品<br>
                    • サンプル版やデモ版として貸与されている商品<br>
                    • 外箱及び内箱などに破損や著しい汚れ、傷みのある商品<br>
                    • 日本国内で免税購入したと疑いのある商品<br>
                    • 着払い条件を満たした場合は、着払い発送をお願いいたします<br>
                    • その他、当店にて購入できる状態の商品ではないと判断した商品<br>
                </p>
        </div>

        <FooterVue></FooterVue>
    </div>
</template>

<script>
import HeaderVue from "../components/Header.vue";
import FooterVue from "../components/FFooter.vue";
export default {
    components: { HeaderVue, FooterVue },
    props: {},
    data() {
        return {};
    },
    mounted() { },
    methods: {},
};
</script>
<style scoped>
.banner {
    width: 77vw;
    margin: 0px auto;
    padding: 20px 0;
    box-sizing: border-box;
    color: #555;
}
</style>